import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';

import { Admis } from 'src/app/model/Admis';
import { UtilisateursService } from 'src/app/modules/utilisateurs/services/utilisateurs.service';

import { AppelsService } from '../../service/appels.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Chart, registerables } from 'chart.js/auto';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { ActivatedRoute } from '@angular/router';
import { Repecher } from 'src/app/model/repecher.model';

Chart.register(...registerables);

export interface AdmisByGender {
  family: String;
  Data: { homme: number; femme: number };
}

@Component({
  selector: 'app-admis',
  templateUrl: './admis.component.html',
  styleUrls: ['./admis.component.css'],
})
export class AdmisComponent implements OnInit, AfterViewInit {
  @ViewChild('notificationButton') toggleButton!: ElementRef;

  AllAdmis: Admis[] = [];
  AllAdmisGender: any[] = [];
  IAhomme!: number;
  IAfemme!: number;
  DEVhomme!: number;
  DEVfemme!: number;
  TECHhomme!: number;
  TECHfemme!: number;
  EBUShomme!: number;
  EBUSfemme!: number;
  CCAhomme!: number;
  CCAfemme!: number;
  totalHomme: number = 0;
  totalFemme: number = 0;
  showModal: boolean = false;
  showMailSent: boolean = false;
  showDetails: boolean = false;
  hide: boolean = false;
  showSpinner = false;
  displayedColumns: string[] = [
    'iuf',
    'prenom',
    'nom',
    'age',
    'mail',
    'confirmation',
    'actions',
  ];
  dataSource = new MatTableDataSource<Admis>();

  allRepecher: Repecher[] = [];
  allRepecherGender: any[] = [];
  repecherIAhomme!: number;
  repecherIAfemme!: number;
  repecherDEVhomme!: number;
  repecherDEVfemme!: number;
  repecherTECHhomme!: number;
  repecherTECHfemme!: number;
  repecherEBUShomme!: number;
  repecherEBUSfemme!: number;
  repecherCCAhomme!: number;
  repecherCCAfemme!: number;
  repecherTotalHomme: number = 0;
  repecherTotalFemme: number = 0;
  repecherTotalGlobalH: number = 0;
  repecherTotalGlobalF: number = 0;
  TotalGlobalHommeFemmeRepecher: number = 0;
  //TotalGlobalHommeFemmeNonRepecher: number = 0;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  // Variables for Graph
  chart!: any;
  chart2!: any;
  hommes: number[] = [];
  femmes: number[] = [];
  CountMaleAdmitted: number[] = [];
  CountFmaleAdmitted: number[] = [];
  NoIAhomme: number = 0;
  NoIAfemme: number = 0;
  NoDEVhomme: number = 0;
  NoDEVfemme: number = 0;
  NoTECHhomme: number = 0;
  NoTECHfemme: number = 0;
  NoEBUShomme: number = 0;
  NoEBUSfemme: number = 0;
  NoCCAhomme: number = 0;
  NoCCAfemme: number = 0;
  NototalHomme: number = 0;
  NototalFemme: number = 0;
  totalGlobalH: number = 0;
  totalGlobalF: number = 0;
  totalGlobalHommeFemmeAdmis: number = 0;
  totalGlobalHommeFemmeNoAdmis: number = 0;

  cohorte: any = null;

  @ViewChild('canvasConfirmation') canvas!: ElementRef<HTMLCanvasElement>;

  ligneDetails!: Admis;

  confirmed!: any;
  notConfirmed!: any;

  breadcrumbItems!: BreadcrumbItem[];

  constructor(
    private appelsService: AppelsService,
    private utilisateurService: UtilisateursService,
    private spinnerService: SpinnerServiceService,
    private route: ActivatedRoute,
  ) {
    this.spinnerService.spinner$.subscribe((data: boolean) => {
      setTimeout(() => {
        this.showSpinner = data ? data : false;
      });
    });
  }

  ngOnInit() {
    this.route.params.subscribe((data: any) => {
      this.cohorte = data['cohortId'];
      this.getlistAdmis(this.cohorte);
      //this.getListAdmisByGender(this.cohorte);
    });
    //this.getlistAdmis();
    this.getListAdmisByGender();

    this.getGenderMaleFemaleAttmited();
    this.getGenderMaleFemaleRepecher();
    this.getSession();

    this.totalGlobalH = this.totalHomme + this.NototalHomme;
    this.totalGlobalF = this.totalFemme + this.NototalFemme;

    // console.log(
    //   'totalFemme - totalHomme',
    //   this.totalFemme + ' ' + this.totalHomme
    // );
    this.breadcrumbItems = [
      { label: 'SIGUI' },
      {
        label: `SESSION ${this.cohorte}`,
        url: `/dashboard/appels/candidatures/${this.cohorte}`,
      },
      { label: 'ADMIS', url: `/dashboard/appels/admis/${this.cohorte}` },
    ];
  }

  ngAfterViewInit(): void {
    this.getConfirmedFromAdmitted();

    const from = sessionStorage.getItem('setItem');
    // //console.log(from)
    if (from == '1') {
      // //console.log("reload")
      window.location.reload();
      sessionStorage.setItem('setItem', '0');
    }
  }

  getlistAdmis(cohorte: string): void {
    this.appelsService
      .getListAdmis(cohorte)
      .pipe()
      .subscribe({
        next: (list: Admis[]) => {
          this.dataSource.data = list;
          this.dataSource.paginator = this.paginator;
        },
        error: (err) => {
          alert('Erreur de Recuperation des Données');
        },
      });
  }

  getListAdmisByGender(): void {
    this.appelsService.getAdmisBySexe().subscribe((data: any) => {
      // console.log(data);

      data['DÉVELOPPEMENT LOGICIEL']?.Homme;
      data['DÉVELOPPEMENT LOGICIEL']?.Féminin;
      this.DEVhomme = data['DÉVELOPPEMENT LOGICIEL']?.Homme;
      this.DEVfemme = data['DÉVELOPPEMENT LOGICIEL']?.Féminin;

      this.IAhomme = data['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.Homme;
      this.IAfemme = data['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.Féminin;

      this.TECHhomme =
        data['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Homme ??
        data['TECHNOLOGIES ÉMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Homme;
      this.TECHfemme =
        data['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Féminin ??
        data['TECHNOLOGIES ÉMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Féminin;

      this.EBUShomme = data['E-BUSINESS']?.Homme;
      this.EBUSfemme = data['E-BUSINESS']?.Féminin;

      this.CCAhomme = data['CRÉATION DE CONTENU AUDIOVISUELS ANIMES']?.Homme;
      this.CCAfemme = data['CRÉATION DE CONTENU AUDIOVISUELS ANIMES']?.Féminin;

      this.totalHomme =
        this.DEVhomme +
        this.IAhomme +
        this.TECHhomme +
        this.EBUShomme +
        this.CCAhomme;
      this.totalFemme =
        this.DEVfemme +
        this.IAfemme +
        this.TECHfemme +
        this.EBUSfemme +
        this.CCAfemme;

      // console.log('f-h :', this.CCAfemme + this.CCAhomme);
    });
  }
  exportPDF(): void {
    this.appelsService.exportToPDF().subscribe(
      (response: Blob) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url); // Ovr nvll fenêtre
      },
      (error) => {
        // console.error('Error exporting PDF:', error);
      },
    );
  }

  exportAdmisExcel() {
    this.appelsService.exportAdmisExcel().subscribe((data) => {
      const blob = new Blob([data], {
        type: 'application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const donnees = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = donnees;
      link.download = 'admis.xlsx';
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        }),
      );

      setTimeout(function () {
        window.URL.revokeObjectURL(donnees);
        link.remove();
      }, 100);
    });
  }

  changeHide() {
    if (this.toggleButton) {
      this.toggleButton.nativeElement.click();
    }
  }

  toggleModal() {
    this.showModal = !this.showModal;
  }

  toggleModalDetails(row: Admis) {
    this.ligneDetails = row;
    this.showDetails = true;
  }
  closeModalDetails() {
    this.showDetails = false;
  }

  notifierMail() {
    this.showModal = !this.showModal;

    this.spinnerService.showSpinner();

    this.appelsService
      .notifierAdmission()
      .pipe()
      .subscribe({
        next: (response) => {
          if (response.status == 200) {
            this.spinnerService.hideSpinner();

            this.showMailSent = true;
          }
        },
        error: (err) => {
          alert("Erreur d'envoi des mails ! Merci reessayer plus tard ");
          this.spinnerService.hideSpinner();
        },
      });
  }

  closeMailSentDialog() {
    this.showMailSent = !this.showMailSent;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  //Nombre des hommes, femme admis
  getGenderMaleFemaleAttmited(): void {
    this.utilisateurService.getAdmittedByFamilyAndGender().subscribe((sexe) => {
      sexe['DÉVELOPPEMENT LOGICIEL']?.Homme;
      sexe['DÉVELOPPEMENT LOGICIEL']?.Féminin;
      //console.log(sexe['DÉVELOPPEMENT LOGICIEL']);
      this.DEVhomme =
        sexe['DÉVELOPPEMENT LOGICIEL']?.Homme != undefined
          ? sexe['DÉVELOPPEMENT LOGICIEL'].Homme
          : 0;
      this.DEVfemme =
        sexe['DÉVELOPPEMENT LOGICIEL']?.Féminin != undefined
          ? sexe['DÉVELOPPEMENT LOGICIEL'].Féminin
          : 0;
      this.IAhomme =
        sexe['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.Homme != undefined
          ? sexe['INTELLIGENCE ARTIFICIELLE & DONNÉES'].Homme
          : 0;
      this.IAfemme =
        sexe['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.Féminin != undefined
          ? sexe['INTELLIGENCE ARTIFICIELLE & DONNÉES'].Féminin
          : 0;
      this.TECHhomme =
        sexe['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Homme ??
        sexe['TECHNOLOGIES ÉMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Homme ??
        0;
      this.TECHfemme =
        sexe['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Féminin ??
        sexe['TECHNOLOGIES ÉMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Féminin ??
        0;
      this.EBUShomme =
        sexe['E-BUSINESS']?.Homme != undefined ? sexe['E-BUSINESS'].Homme : 0;
      this.EBUSfemme =
        sexe['E-BUSINESS']?.Féminin != undefined
          ? sexe['E-BUSINESS'].Féminin
          : 0;

      this.CCAhomme =
        sexe['CRÉATION DE CONTENU AUDIOVISUELS ANIMES']?.Homme != undefined
          ? sexe['CRÉATION DE CONTENU AUDIOVISUELS ANIMES'].Homme
          : 0;
      this.CCAfemme =
        sexe['CRÉATION DE CONTENU AUDIOVISUELS ANIMES']?.Féminin != undefined
          ? sexe['CRÉATION DE CONTENU AUDIOVISUELS ANIMES'].Féminin
          : 0;

      this.totalHomme =
        this.DEVhomme +
        this.IAhomme +
        this.TECHhomme +
        this.EBUShomme +
        this.CCAhomme;
      this.totalFemme =
        this.DEVfemme +
        this.IAfemme +
        this.TECHfemme +
        this.EBUSfemme +
        this.CCAfemme;

      //console.log('test admis donnees ', this.totalFemme);
      //console.log('test admis donnees ', this.totalHomme);

      this.updateTotalGlobal();
    });
  }

  //Nombre des hommes, femme repecher
  getGenderMaleFemaleRepecher(): void {
    // console.log('[Repecher] Chargement des données par famille et genre...');

    this.utilisateurService
      .getRepecherByFamilyAndGender(this.cohorte)
      .subscribe({
        next: (sexe) => {
          // console.log('[Repecher] Données brutes reçues :', sexe);

          this.repecherDEVhomme = sexe['DÉVELOPPEMENT LOGICIEL']?.Homme ?? 0;
          this.repecherDEVfemme = sexe['DÉVELOPPEMENT LOGICIEL']?.Féminin ?? 0;
          this.repecherIAhomme =
            sexe['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.Homme ?? 0;
          this.repecherIAfemme =
            sexe['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.Féminin ?? 0;
          this.repecherTECHhomme =
            sexe['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Homme ??
            sexe['TECHNOLOGIES ÉMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Homme ??
            0;
          this.repecherTECHfemme =
            sexe['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Féminin ??
            sexe['TECHNOLOGIES ÉMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Féminin ??
            0;
          this.repecherEBUShomme = sexe['E-BUSINESS']?.Homme ?? 0;
          this.repecherEBUSfemme = sexe['E-BUSINESS']?.Féminin ?? 0;
          this.repecherCCAhomme =
            sexe['CRÉATION DE CONTENU AUDIOVISUELS ANIMES']?.Homme ?? 0;
          this.repecherCCAfemme =
            sexe['CRÉATION DE CONTENU AUDIOVISUELS ANIMES']?.Féminin ?? 0;

          this.repecherTotalHomme =
            this.repecherDEVhomme +
            this.repecherIAhomme +
            this.repecherTECHhomme +
            this.repecherEBUShomme +
            this.repecherCCAhomme;

          this.repecherTotalFemme =
            this.repecherDEVfemme +
            this.repecherIAfemme +
            this.repecherTECHfemme +
            this.repecherEBUSfemme +
            this.repecherCCAfemme;

          /*console.log('[Repecher] Résultats par famille :', {
            DEV: { homme: this.repecherDEVhomme, femme: this.repecherDEVfemme },
            IA: { homme: this.repecherIAhomme, femme: this.repecherIAfemme },
            TECH: {
              homme: this.repecherTECHhomme,
              femme: this.repecherTECHfemme,
            },
            EBUS: {
              homme: this.repecherEBUShomme,
              femme: this.repecherEBUSfemme,
            },
            CCA: { homme: this.repecherCCAhomme, femme: this.repecherCCAfemme },
          });
          console.log('[Repecher] Total homme :', this.repecherTotalHomme);
          console.log('[Repecher] Total femme :', this.repecherTotalFemme);*/

          this.updateTotalGlobal();
        },
        error: (err) => {
          console.error(
            '[Repecher] Erreur lors de la récupération des données :',
            err,
          );
        },
      });
  }

  getConfirmedFromAdmitted() {
    this.spinnerService.showSpinner();
    this.utilisateurService
      .getConfirmed()
      .pipe()
      .subscribe({
        next: (stats) => {
          this.confirmed = stats?.['Confirmé'];
          this.notConfirmed = stats?.['Pas encore confirmé'];

          this.setTotalConfirmed_NoConfirmedChart('Le nombre de confirmation');
        },
        error: (err) => {
          alert('Erreur de Recuperation des Données');
        },
      });
  }

  // mettre à jr la somme totale
  // updateTotalGlobal(): void {
  //   // Calcul de la somme totale
  //   this.totalGlobalH = this.totalHomme + this.totalFemme;
  //   this.totalGlobalF = this.NototalHomme + this.NototalFemme;
  //   this.totalGlobalHommeFemmeAdmis = this.totalHomme + this.totalFemme;
  //   this.totalGlobalHommeFemmeNoAdmis = this.NototalHomme + this.NototalFemme;
  // }

  updateTotalGlobal(): void {
    // Calcul de la somme totale
    this.totalGlobalH = this.totalHomme + this.totalFemme;
    this.totalGlobalF = this.repecherTotalHomme + this.repecherTotalFemme;
    this.totalGlobalHommeFemmeAdmis = this.totalHomme + this.totalFemme;
    this.TotalGlobalHommeFemmeRepecher =
      this.repecherTotalHomme + this.repecherTotalFemme;

    /*console.log('[Global] Totaux mis à jour :', {
      totalGlobalH: this.totalGlobalH,
      totalGlobalF: this.totalGlobalF,
      totalGlobalHommeFemmeAdmis: this.totalGlobalHommeFemmeAdmis,
      TotalGlobalHommeFemmeRepecher: this.TotalGlobalHommeFemmeRepecher,
    });*/
  }

  // Methode pour dessiner le diagramme Répartition du nombre dadmis par famille de métier et par catégorie
  setCategoryChart(
    canvasName: string,
    c1Data: number[],
    c2Data: number[],
    c3Data: number[],
    c4Data: number[],
    c5Data: number[],
    c6Data: number[],
    title: string,
    colors: {
      c1: string;
      c2: string;
      c3: string;
      c4: string;
      c5: string;
      c6: string;
    },
  ) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      this.chart2 = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['IA/D', 'E-Bus', 'DEV-LOG', 'TE/Cybs'],
          datasets: [
            {
              label: 'C1',
              data: c1Data,
              backgroundColor: colors.c1,
              borderColor: 'rgb(54, 162, 235)',
              borderWidth: 1,
            },
            {
              label: 'C2',
              data: c2Data,
              backgroundColor: colors.c2,
              borderColor: 'rgb(255, 99, 132)',
              borderWidth: 1,
            },
            {
              label: 'C3',
              data: c3Data,
              backgroundColor: colors.c3,
              borderColor: 'rgb(255, 205, 86)',
              borderWidth: 1,
            },
            {
              label: 'C4',
              data: c4Data,
              backgroundColor: colors.c4,
              borderColor: 'rgb(255, 159, 64)',
              borderWidth: 1,
            },
            {
              label: 'C5',
              data: c5Data,
              backgroundColor: colors.c5,
              borderColor: 'rgb(0, 128, 0)',
              borderWidth: 1,
            },
            {
              label: 'C6',
              data: c6Data,
              backgroundColor: colors.c6,
              borderColor: 'rgb(255, 0, 255)',
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: title,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
        },
      });
    }
  }

  setTotalConfirmed_NoConfirmedChart(title: string) {
    const ctx = this.canvas.nativeElement.getContext('2d');
    if (ctx) {
      if (this.chart) {
        this.chart.destroy(); // Nettoyer le graphique précédent s'il existe
      }

      this.chart = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: ['Confirmé', 'Pas encore confirmé'],
          datasets: [
            {
              label: 'My First Dataset',
              data: [this.confirmed, this.notConfirmed],
              backgroundColor: ['rgb(14, 159, 110)', 'rgb(240, 82, 82)'],
              hoverOffset: 4,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: title,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: { stacked: true },
            y: { stacked: true },
          },
        },
      });

      this.spinnerService.hideSpinner();
    }
  }

  getSession() {
    this.cohorte = sessionStorage.getItem('cohorte');
    // console.log('cohrote :', this.cohorte);
  }

  /*   setTotalConfirmed_NoConfirmedChart(
    canvasName: string,
    admisData: number,
    noAdmisData: number,
    title: string
  ) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');
    // //console.log("After View")

    if (ctx) {
      this.chart = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: ['Confirmé', 'Pas encore confirmé'],
          datasets: [
            {
              label: 'My First Dataset',
              data: [admisData, noAdmisData],
              backgroundColor: [
                'rgb(14, 159, 110)',
                'rgb(240, 82, 82)',
                // 'rgb(255, 205, 86)'
              ],
              hoverOffset: 4,
            },
          ],
        },

        options: {
          plugins: {
            title: {
              display: true,
              text: title,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
        },
      });
    }
  } */
}